import { CircularProgress, List, ListItem, Divider } from "@mui/material";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import SelectField from "../../../Components/SelectField";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
    minWidth: '520px',
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2, fontFamily: "Quicksand" }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

export const CreateLocationDialog = ({
  LocatehandleClose,
  Locateopen,
  setLocation,
  AllEmployee,
  submitlocation,
  isLoading,
  Location
}) => {
  const dashboardTheme = window.localStorage.getItem("theme");
  return (
    <BootstrapDialog
      onClose={LocatehandleClose}
      aria-labelledby="customized-dialog-title"
      open={Locateopen}
    >
      <BootstrapDialogTitle
        id="customized-dialog-title"
        onClose={LocatehandleClose}
      >
        <div className="foundation_header">Create Location</div>
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <div className="Form_Box">
          <div className="Box">
            <label>name</label>
            <input
              name="name"
              value={Location.name}
              onChange={(e) =>
                setLocation({ ...Location, name: e.target.value })
              }
              type="text"
            />
          </div>

          <div className="Box">
            <label>Head of Location</label>
            <SelectField
              name="head_of_location"
              onChange={(e) =>
                setLocation({
                  ...Location,
                  head_of_location: e.value,
                })
              }
              options={AllEmployee}
              value={AllEmployee?.find(
                (item) => item?.value === Location?.head_of_location
              )}
            />
          </div>

          <div className="Box">
            <label>description</label>
            <input
              name="description"
              value={Location.description}
              onChange={(e) =>
                setLocation({ ...Location, description: e.target.value })
              }
              type="text"
            />
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <div className="Form_Btn_Wrapper">
          <button onClick={LocatehandleClose} className="Btn">
            Cancel
          </button>
          <button
            className="Btn"
            onClick={submitlocation}
            style={{
              backgroundColor: dashboardTheme ? dashboardTheme : "#13ABF4",
            }}
          >
            {isLoading === true ? (
              <CircularProgress color="inherit" size={20} />
            ) : (
              "submit"
            )}
          </button>
        </div>
      </DialogActions>
    </BootstrapDialog>
  );
};

export const EditLocationDialog = ({
  handleEditLocateClose,
  editLocate,
  AllLocation,
  setLocation,
  AllEmployee,
  updateLocation,
  Location,
  isLoading,
}) => {
  const dashboardTheme = window.localStorage.getItem("theme");
  return (
    <BootstrapDialog
      onClose={handleEditLocateClose}
      aria-labelledby="customized-dialog-title"
      open={editLocate !== null}
    >
      <BootstrapDialogTitle
        id="customized-dialog-title"
        onClose={handleEditLocateClose}
      >
        <div className="foundation_header">Edit Location</div>
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <div className="Form_Box">
          <div className="Box">
            <label>name</label>
            <input
              name="name"
              value={Location.name}
              placeholder={
                AllLocation !== ""
                  ? AllLocation?.find((item) => item.id === editLocate)?.name
                  : ""
              }
              onChange={(e) =>
                setLocation({ ...Location, name: e.target.value })
              }
              type="text"
            />
          </div>

          <div className="Box">
            <label>Head of Location</label>
            <SelectField
              name="head_of_location"
              onChange={(e) =>
                setLocation({
                  ...Location,
                  head_of_location: e.value,
                })
              }
              de
              options={AllEmployee}
              value={AllEmployee?.find(
                (item) => item?.value === Location?.head_of_location
              )}
            />
          </div>

          <div className="Box">
            <label>description</label>
            <input
              name="description"
              value={Location.description}
              placeholder={
                AllLocation !== ""
                  ? AllLocation?.find((item) => item.id === editLocate)
                      ?.description
                  : ""
              }
              onChange={(e) =>
                setLocation({ ...Location, description: e.target.value })
              }
              type="text"
            />
          </div>

          {/* <div className="Box">
              <label>Start Date</label>
              <input
                name="startDate"
                value={Location.start_date}
                placeholder={
                  AllLocation !== ""
                    ? AllLocation?.find((item) => item.id === editLocate)
                        ?.startDate
                    : ""
                }
                onChange={(e) =>
                  setLocation({ ...Location, start_date: e.target.value })
                }
                type="date"
              />
            </div> */}
        </div>
      </DialogContent>
      <DialogActions>
        <div className="Form_Btn_Wrapper">
          <button onClick={handleEditLocateClose} className="Btn">
            Cancel
          </button>
          <button
            className="Btn"
            onClick={updateLocation}
            style={{
              backgroundColor: dashboardTheme ? dashboardTheme : "#13ABF4",
            }}
          >
            {isLoading === true ? (
              <CircularProgress
                color="inherit"
                size={20}
                onClick={updateLocation}
              />
            ) : (
              "submit"
            )}
          </button>
        </div>
      </DialogActions>
    </BootstrapDialog>
  );
};

export const DeleteLocationDialog = ({
  handleDeleteLocateClose,
  deleteLocate,
  isLoading,
  deleteLocation,
}) => {
  const dashboardTheme = window.localStorage.getItem("theme");
  return (
    <BootstrapDialog
      onClose={handleDeleteLocateClose}
      aria-labelledby="customized-dialog-title"
      open={deleteLocate !== null}
    >
      <BootstrapDialogTitle
        id="customized-dialog-title"
        onClose={handleDeleteLocateClose}
      >
        <div className="foundation_header">Delete Location</div>
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <div className="Confirmation">Are you sure?</div>
      </DialogContent>
      <DialogActions>
        <div className="Form_Btn_Wrapper">
          <button onClick={handleDeleteLocateClose} className="Btn">
            Cancel
          </button>
          <button
            className="Delete_Btn"
            style={{
              backgroundColor: dashboardTheme ? dashboardTheme : "#13ABF4",
            }}
            onClick={deleteLocation}
          >
            {isLoading === true ? (
              <CircularProgress
                color="inherit"
                size={20}
              />
            ) : (
              "Delete"
            )}
          </button>
        </div>
      </DialogActions>
    </BootstrapDialog>
  );
};

export const ViewLocationDialog = ({
  handleViewLocateClose,
  LocateViewopen,
  employee,
}) => {
  return (
    <BootstrapDialog
      onClose={handleViewLocateClose}
      aria-labelledby="customized-dialog-title"
      open={LocateViewopen !== null}
    >
      <BootstrapDialogTitle
        id="customized-dialog-title"
        onClose={handleViewLocateClose}
      >
        <div className="foundation_header">View Location</div>
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <List>
          <ListItem
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <label>Name</label>
            <p>{LocateViewopen?.location}</p>
          </ListItem>
          <Divider style={{ backgroundColor: "rgba(0,0,0,0.5" }} />
          <ListItem
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <label>Head of Location</label>
            <p>{`${employee?.label??"Nil"}`}</p>
          </ListItem>
          <Divider style={{ backgroundColor: "rgba(0,0,0,0.5" }} />
          <ListItem
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <label>Description</label>
            <p>{LocateViewopen?.description}</p>
          </ListItem>
        </List>
      </DialogContent>
    </BootstrapDialog>
  );
};